import React from "react"
import Metas from "../components/Metas"
import About from "../components/about"
import MainLayout from "../components/MainLayout"
import StackOverFlow from "../components/StackOverFlow"
import Banner from "../components/banner"
import Skills from "../components/skills"
import Experience from "../components/experience"

const IndexPage = () => (
  <MainLayout>
    <Metas title="Mohit K Srivastava | Mohit S | Home" />
    <Banner />
    <About />
    <Experience />
    <Skills />
    <StackOverFlow postSize={1} />
  </MainLayout>
)

export default IndexPage
